import { motion } from "framer-motion";
import { Rocket, Gauge, Activity, Bot, CalendarRange, Trophy } from "lucide-react";
import { SectionHeading, FadeUp } from "./Reveal";

const PRODUCTS = [
  { name: "JIYONOX Orchestrator", desc: "Provision, deploy and operate digital applications and client environments.", Icon: Rocket, status: "Emerging" },
  { name: "JIYONOX Command Center", desc: "Unified dashboard for digital health, applications, infrastructure, analytics, AI, support and billing.", Icon: Gauge, status: "Emerging" },
  { name: "Digital Health Score", desc: "Continuous monitoring and optimization of digital properties.", Icon: Activity, status: "Emerging" },
  { name: "AI Workforce", desc: "Reusable intelligent agents for business operations.", Icon: Bot, status: "Emerging" },
  { name: "EventOS", desc: "End-to-end event registration and operations platform.", Icon: CalendarRange, status: "Emerging" },
  { name: "CricketPro", desc: "Modern tournament, scoring, analytics and broadcast operating platform.", Icon: Trophy, status: "Emerging" },
];

export const Products = () => (
  <section id="products" data-testid="products-section" className="py-24 sm:py-32 bg-jx-night text-white relative overflow-hidden">
    <div className="pointer-events-none absolute top-0 right-1/4 w-[520px] h-[420px] rounded-full bg-jx-purple/25 blur-[130px]" />
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="grid lg:grid-cols-12 gap-10 items-end">
        <div className="lg:col-span-8">
          <SectionHeading
            dark
            testId="products"
            overline="Products"
            title={<>Platforms designed to become <span className="jx-gradient-text">smarter over time.</span></>}
          />
        </div>
        <FadeUp delay={0.2} className="lg:col-span-4">
          <p className="text-sm text-white/45 leading-relaxed lg:text-right">Emerging JIYONOX products — purpose-built platforms, not all generally available yet.</p>
        </FadeUp>
      </div>

      <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {PRODUCTS.map((p, i) => (
          <FadeUp key={p.name} delay={(i % 3) * 0.1}>
            <motion.div
              data-testid={`product-card-${i}`}
              whileHover={{ y: -6 }}
              transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
              className="group relative h-full rounded-3xl jx-glass-dark p-8 overflow-hidden hover:border-jx-magenta/40 transition-colors duration-300"
            >
              <div className="absolute -top-16 -right-16 w-40 h-40 rounded-full jx-gradient-bg opacity-0 blur-2xl group-hover:opacity-25 transition-opacity duration-500" />
              <div className="flex items-start justify-between">
                <div className="w-12 h-12 rounded-2xl bg-white/[0.07] border border-white/10 flex items-center justify-center group-hover:jx-gradient-bg transition-colors duration-400">
                  <p.Icon className="w-5 h-5 text-jx-copper group-hover:text-white transition-colors duration-300" strokeWidth={1.8} />
                </div>
                <span className="rounded-full border border-jx-copper/40 text-jx-copper text-[10px] font-bold tracking-widest uppercase px-3 py-1">{p.status}</span>
              </div>
              <h3 className="mt-6 font-display font-bold text-xl tracking-tight text-white">{p.name}</h3>
              <p className="mt-3 text-sm leading-relaxed text-white/55">{p.desc}</p>
            </motion.div>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
